import React from 'react';
// api
import api from '../../../utils/api';
// components
import Form from '../../../components/Form/Form';
import FieldError from '../../../components/Form/FieldError';
import Button from '../../../components/Button/Button';
import Input from '../../../components/Input/Input';
// utils
import { toast } from 'react-toastify';
import { withFormik } from 'formik';
import { responseErrors, toastResponseErrors } from '../../../utils/response';
import * as yup from 'yup';

export const SupportPersonFrom = ({
  supportPerson,
  isZero,
  values,
  touched,
  errors = {},
  isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit,
  deleteUserSupport,
  color
}) => {
  const isDisabled = isSubmitting || !!supportPerson || isZero;
  return (
    <Form horizontal onSubmit={handleSubmit}>
      {/* email */}
      <div className="form-control">
        <Input
          name="email"
          placeholder="person@email.com"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={isDisabled}
          invalid={errors.email && touched.email}
        />
        <FieldError error={errors.email} touched={touched.email} />
      </div>
      {!supportPerson && (
        <Button
          type="submit"
          isLoading={isSubmitting}
          disabled={isDisabled}
          color={color}
        >
          Invite
        </Button>
      )}
      {supportPerson && <Button onClick={deleteUserSupport}>Remove</Button>}
    </Form>
  );
};

export default withFormik({
  enableReinitialize: true,
  mapPropsToValues: ({ supportPerson }) => ({
    email: supportPerson ? supportPerson.email : ''
  }),
  validationSchema: yup.object().shape({
    email: yup
      .string()
      .email('Invalid email address')
      .required('Email is required!')
  }),
  handleSubmit: (values, { setSubmitting, setErrors, resetForm }) => {
    return api.auth
      .inviteSupport(values.email)
      .then(() => {
        toast.success(
          `Invitation has been successfully sent to ${values.email}`
        );
        setSubmitting(false);
        resetForm();
      })
      .catch(response => {
        const errors = responseErrors(response);
        setErrors(response);
        setSubmitting(false);
        errors && errors.common && toastResponseErrors(response, 'common');
        !response.data && toastResponseErrors(response, 'message');
        typeof errors === 'string' && toastResponseErrors(response);
      });
  },
  displayName: 'SupportPersonFrom'
})(SupportPersonFrom);



// WEBPACK FOOTER //
// ./src/containers/UserProfile/components/SupportPersonForm.jsx